/**
 * 获取饼图数据
 * @param statistic
 * @returns {*|*[]|*[]}
 */
export const getCommonPieData = (statistic) => {
  let data = []
  if (!statistic) {
    return data
  }
  data = statistic.map(item => {
    return {
      name: item.statisticalName,
      value: item.count
    }
  })
  return data
}
/**
 * 获取柱状图数据
 * @param statistic
 * @returns {{seriesData: *[], xAxisData: *[]}}
 */
export const getCommonBarData = (statistic) => {
  let data = {
    xAxisData: [],
    seriesData: []
  }
  if (!statistic) {
    return data
  }
  statistic.forEach(item => {
    data.seriesData.push(item.count)
    data.xAxisData.push(item.statisticalName)
  })
  return data
}

/**
 * 获取柱状图和饼图数据
 * @param statistic
 * @returns {{extractSeriesData: *[], attendSeriesData: *[], busySeriesData: *[], projectSeriesData: *[], xAxisData: *[]}}
 */
export const getCommonBarWithPieData = (statistic) => {
  let data = {
    xAxisData: [],
    projectSeriesData: [],
    extractSeriesData: [],
    attendSeriesData: [],
    busySeriesData: [],
  }
  if (!statistic) {
    return data
  }
  statistic.forEach(item => {
    data.xAxisData.push(item.month)
    data.projectSeriesData.push(item.projectCount)
    data.extractSeriesData.push(item.expertExtractCount)
    data.attendSeriesData.push(item.expertAttendCount)
    data.busySeriesData.push(item.expertBusyCount)
  })
  return data
}
